import { generateActions } from 'redux-dryer';

const Actions = {
  setCompanyName: (companyName: string) => ({ companyName }),
  setCurrentSection: (currentSection: string) => ({ currentSection }),
} as const;

export default generateActions(Actions, 'head');
